import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import {environment} from "@environment";

@Directive({
  selector: '[appImageFallback]'
})
export class ImageFallbackDirective {
  @Input() fallbackUrl: string = `${environment.assetsImagesPath}/assets/img/mountain.png`;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.renderer.listen(this.el.nativeElement, 'error', (event) => {
      this.renderer.setAttribute(this.el.nativeElement, 'src', this.fallbackUrl);
    });
  }
}
